import { render, staticRenderFns } from "./BetaWarning.vue?vue&type=template&id=767eb291&scoped=true"
import script from "./BetaWarning.vue?vue&type=script&lang=js"
export * from "./BetaWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767eb291",
  null
  
)

export default component.exports